import { SectionScroll } from '../home/SectionScroll'
import { Link } from 'react-router-dom'
import { products } from '../../data/shop/products'
import { MerchandiseCarousel } from './MerchandiseCarousel'
import './merchandise.css'
const merchandise = products.filter(product => product.category !== 'hardware' && product.status !== 'discontinued')

export function MerchandiseSection() {
  return <section id="merchandise" className="merch-section" aria-labelledby="merch-heading" tabIndex={-1}>
    <header className="merch-heading"><div><span className="merch-eyebrow">04 / ALDAPA SYSTEMS MERCHANDISE</span><h2 id="merch-heading">Engineered for the Curious.</h2><p>Explore Aldapa Systems merchandise inspired by nuclear engineering, scientific discovery, and the technologies shaping tomorrow.</p></div><Link to="/shop">Explore all merchandise <span aria-hidden="true">↗</span></Link></header>
    <MerchandiseCarousel products={merchandise} />
    <SectionScroll target="neutron-challenge" label="Play Neutron Invaders" />
  </section>
}
